export default "/kiban/_next/static/images/photolithography-9a9d3c8f88daf01b3c26b1f9d7c5be8a.png";